module.exports = __webpack_public_path__ + "res/ic_arrow_big_small_m.74abbc6a99bfa197a716dfa05f6a8bd3.png";